import React, {Component} from 'react'
import Article from './article'


class Credits extends Component {

    render() {
        return (
            <div>
                <Article title="Edição em papel"
                         text="Manoel Mourivaldo Santiago-Almeida, 2011"/>

                <Article title="Corpo editorial"
                         text="Adriano Scatolin, Alexandre B.deSouza,"/>

                <Article text="Bruno Costa, Caio Gagliardi, Fábio Mantegari,"/>

                <Article text="Felipe C.Pedro, Iuri Pereira, Jorge Sallum,"/>

                <Article text="Oliver Tolle, Ricardo Musse, Ricardo Valle"/>

                <Article title="Equipe de revisão técnica"/>

                <Article text="Adélia Maria Mariano da S.Ferreira,"/>
                <Article text="Alberto Ribeiro Rosa Júnior,"/>
                <Article text="Bruno Lins da Costa Borges,"/>
                <Article text="Camila Maria Camargo de Oliveira,"/>
                <Article text="Dionizio Bueno de Souza,"/>
                <Article text="Pe. Edmílson José Zanin,"/>
                <Article text="Marlos Antonio Borges,"/>
                <Article text="Rodrigo Carvalho de Oliveira"/>
                <Article text="Rosa Maria de Lima e Souza,"/>
                <Article text="Rosane de Sá Amado,"/>
                <Article text="Waldemar Ferreira Netto"/>
                <Article text=""/>
                <Article text=""/>
                <Article text=""/>
                <Article text=""/>

                <Article title="Coordenação editorial"
                         text="Jorge Sallum"/>

                <Article title="Projeto gráfico"
                         text="Bruno Oliveira e Jorge Sallum"/>

                <Article title="Diagramação"
                         text="Bruno Oliveira"/>


                <Article title="Consultoria de programação "
                         text="Marcelo Freitas"/>

                <Article title="Versão web"
                         text="Sandro Fernandes"/>

                <Article text="Grafia atualizada segundo o Acordo Ortográfico da Língua Portuguesa de 1990, em vigor no Brasil desde 2009. "/>
            </div>
        )
    }
}

export default Credits



// WEBPACK FOOTER //
// ./src/credits.jsx